export default class ScrollItem {

    constructor(
       public readonly label: string,
       public readonly value: string,
    ) { }
}
